import { NewdanhmucnhacungcapService } from 'src/services/newdanhmucnhacungcap.service';
import { showToast } from 'src/utils/common';
import { NOTI_TYPES } from 'src/utils/constants';

import { AppAction } from './app.action';

export const NEWDANHMUCNHACUNGCAP_NEW_CARE_SUCCESS = 'NEWDANHMUCNHACUNGCAP:NEW_CARE_SUCCESS'
export const NEWDANHMUCNHACUNGCAP_LIST_SUCCESS = 'NEWDANHMUCNHACUNGCAP:FIND_ALL_SUCCESS'
export const NEWDANHMUCNHACUNGCAP_LIST_FAILD = 'NEWDANHMUCNHACUNGCAP:FIND_ALL_FAILD'
export const NEWDANHMUCNHACUNGCAP_COUNT_ASSIGN_SUCCESS = 'NEWDANHMUCNHACUNGCAP:COUNT_ASSIGN_SUCCESS'
export const NEWDANHMUCNHACUNGCAP_COUNT_ASSIGN_FAILD = 'NEWDANHMUCNHACUNGCAP:COUNT_ASSIGN_FAILD'

export const NEWDANHMUCNHACUNGCAP_CREATE_SUCCESS = 'NEWDANHMUCNHACUNGCAP:CREATE_SUCCESS'
export const NEWDANHMUCNHACUNGCAP_CREATE_FAILD = 'NEWDANHMUCNHACUNGCAP:CREATE_FAILD'

export const NEWDANHMUCNHACUNGCAP_IMPORT_SUCCESS = 'NEWDANHMUCNHACUNGCAP:IMPORT_SUCCESS'
export const NEWDANHMUCNHACUNGCAP_SAVE_SUCCESS = 'NEWDANHMUCNHACUNGCAP:SAVE_SUCCESS'
export const NEWDANHMUCNHACUNGCAP_SAVE_FAILD = 'NEWDANHMUCNHACUNGCAP:SAVE_SUCCESS'

export const NEWDANHMUCNHACUNGCAP_DEL_SUCCESS = 'NEWDANHMUCNHACUNGCAP:DEL_SUCCESS'
export const NEWDANHMUCNHACUNGCAP_DEL_FAILD = 'NEWDANHMUCNHACUNGCAP:DEL_FAILD'

export const NEWDANHMUCNHACUNGCAP_ONE_SUCCESS = 'NEWDANHMUCNHACUNGCAP:FIND_ONE_SUCCESS'
export const NEWDANHMUCNHACUNGCAP_ONE_FAILD = 'NEWDANHMUCNHACUNGCAP:FIND_ONE_FAILD'

export const NEWDANHMUCNHACUNGCAP_HISTORY_LIST_SUCCESS = 'NEWDANHMUCNHACUNGCAP:HISTORY_FIND_ALL_SUCCESS'
export const NEWDANHMUCNHACUNGCAP_HISTORY_LIST_FAILD = 'NEWDANHMUCNHACUNGCAP:HISTORY_FIND_ALL_FAILD'

export const NEWDANHMUCNHACUNGCAP_UPDATE_FILTER = 'NEWDANHMUCNHACUNGCAP:NEWDANHMUCNHACUNGCAP_UPDATE_FILTER'

export const NEWDANHMUCNHACUNGCAP_LIST_EXPORT_SUCCESS = 'NEWDANHMUCNHACUNGCAP:FIND_ALL_EXPORT_SUCCESS'
export const NEWDANHMUCNHACUNGCAP_LIST_EXPORT_FAILD = 'NEWDANHMUCNHACUNGCAP:FIND_ALL_EXPORT_FAILD'

export const NEWDANHMUCNHACUNGCAP_UPDATE_HOMEPAGE_FILTER = 'NEWDANHMUCNHACUNGCAP:NEWDANHMUCNHACUNGCAP_UPDATE_HOMEPAGE_FILTER'

export const NEWDANHMUCNHACUNGCAP_HOMEPAGE_LIST_SUCCESS = 'NEWDANHMUCNHACUNGCAP:FIND_HOMEPAGE_LIST_SUCCESS'
export const NEWDANHMUCNHACUNGCAP_HOMEPAGE_LIST_FAILD = 'NEWDANHMUCNHACUNGCAP:FIND_HOMEPAGE_LIST_FAILD'

export const NEWDANHMUCNHACUNGCAP_HOMEPAGE_ONE_SUCCESS = 'NEWDANHMUCNHACUNGCAP:FIND_HOMEPAGE_ONE_SUCCESS'
export const NEWDANHMUCNHACUNGCAP_HOMEPAGE_ONE_FAILD = 'NEWDANHMUCNHACUNGCAP:FIND_HOMEPAGE_ONE_FAILD'

export const NEWDANHMUCNHACUNGCAP_ORDER_SUCCESS = 'NEWDANHMUCNHACUNGCAP:ORDER_SUCCESS'
export const NEWDANHMUCNHACUNGCAP_ORDER_FAILD = 'NEWDANHMUCNHACUNGCAP:ORDER_FAILD'

export const NEWDANHMUCNHACUNGCAP_GET_SIM_ANALYSIS_SUCCESS = 'NEWDANHMUCNHACUNGCAP:GET_SIM_ANALYSIS_SUCCESS'
export const NEWDANHMUCNHACUNGCAP_GET_SIM_ANALYSIS_FAILD = 'NEWDANHMUCNHACUNGCAP:GET_SIM_ANALYSIS_FAILD'

export const NEWDANHMUCNHACUNGCAP_HANDLE_IMPORT_ERRORS = 'NEWDANHMUCNHACUNGCAP:NEWDANHMUCNHACUNGCAP_HANDLE_IMPORT_ERRORS'

export const NewdanhmucnhacungcapAction = {
    list,
    findAssign,
    create,
    importData,
    saveData,
    update,
    del,
    assign,
    countAssign,
    history,
    findOne,
    updateFilter,
    saveDataUpload,
    findPackage,
    listExport,
    listNoLimit,
    homepageList,
    updateHomepageFilter,
    homepageFindOne,
    sendOrder,
    getSimAnalysis,
    nhacungcapList,
}

function nhacungcapList() {    
    return (dispatch, getState) => {
        return new Promise((resolve, reject) => {
            // Perform your asynchronous operation (e.g., API call)
            NewdanhmucnhacungcapService.nhacungcapList()
            .then(response => {
                // Handle the successful response
                resolve(response); // Resolve the promise with the response
            })
            .catch(error => {
                // Handle the error
                reject(error); // Reject the promise with the error
            });
        });
    };
}

function getSimAnalysis(number) {
    return (dispatch) => {
        return new Promise((resolve, reject) => {
            // dispatch(AppAction.appLoading(true));
            NewdanhmucnhacungcapService.getSimAnalysis(number).then((response) => {
                dispatch(success(response.data));
                resolve(response);
            }).catch((error) => {
                dispatch(failure(error));
                reject(error);
            }).finally(() => {
                // dispatch(AppAction.appLoading(false));
            })
        })
    };
    function success(data) { return { type: NEWDANHMUCNHACUNGCAP_GET_SIM_ANALYSIS_SUCCESS, data } }
    function failure(error) { return { type: NEWDANHMUCNHACUNGCAP_GET_SIM_ANALYSIS_FAILD, error } }
}

function updateHomepageFilter(payload) {
    return { type: NEWDANHMUCNHACUNGCAP_UPDATE_HOMEPAGE_FILTER, data: payload }
}

function homepageList() {
    return (dispatch, getState) => {
        const { newdanhmucnhacungcap } = getState();
        dispatch(AppAction.appLoading(true));

        const { homepageNewdanhmucnhacungcapFilter } = newdanhmucnhacungcap;
        const homepageNewdanhmucnhacungcapPage = homepageNewdanhmucnhacungcapFilter.homepageNewdanhmucnhacungcapPage;
        const homepageNewdanhmucnhacungcapLimit = homepageNewdanhmucnhacungcapFilter.homepageNewdanhmucnhacungcapLimit;

        return new Promise((resolve, reject) => {
            NewdanhmucnhacungcapService.homepageList(homepageNewdanhmucnhacungcapFilter).then((rs) => {
                if (!!homepageNewdanhmucnhacungcapFilter && homepageNewdanhmucnhacungcapFilter.homepageNewdanhmucnhacungcapPage === 0) {
                    dispatch(success({
                        homepageNewdanhmucnhacungcapItems: rs.data.values,
                        homepageNewdanhmucnhacungcapTotal: rs.data.count,
                    }));
                } else {
                    const oldItems = newdanhmucnhacungcap.homepageNewdanhmucnhacungcapItems;
                    const rsDataValues = rs.data.values;

                    var uniqueItems = oldItems;
                    for (var i = homepageNewdanhmucnhacungcapLimit * homepageNewdanhmucnhacungcapPage; i < homepageNewdanhmucnhacungcapLimit * homepageNewdanhmucnhacungcapPage + homepageNewdanhmucnhacungcapLimit; i++) {
                        if (typeof rsDataValues[i - homepageNewdanhmucnhacungcapLimit * homepageNewdanhmucnhacungcapPage] !== 'undefined') {
                            uniqueItems[i] = rsDataValues[i - homepageNewdanhmucnhacungcapLimit * homepageNewdanhmucnhacungcapPage];
                        } else if (typeof uniqueItems[i] !== 'undefined') {
                            delete uniqueItems[i];
                        }
                    }
                    
                    dispatch(success({
                        homepageNewdanhmucnhacungcapItems: uniqueItems,
                        homepageNewdanhmucnhacungcapTotal: rs.data.count,
                    }));
                }
                resolve(rs);
            }).catch((error) => {
                dispatch(failure(error));
                reject(error);
            }).finally(() => {
                dispatch(AppAction.appLoading(false));
            })
        });
    };
    function success(data) { return { type: NEWDANHMUCNHACUNGCAP_HOMEPAGE_LIST_SUCCESS, data } }
    function failure(error) { return { type: NEWDANHMUCNHACUNGCAP_HOMEPAGE_LIST_FAILD, error } }
}

function homepageFindOne(id) {
    return (dispatch) => {
        dispatch(AppAction.appLoading(true));
        NewdanhmucnhacungcapService.homepageFindOne(id).then((rs) => {
            dispatch(success(rs.data));
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: NEWDANHMUCNHACUNGCAP_HOMEPAGE_ONE_SUCCESS, data } }
    function failure(error) { return { type: NEWDANHMUCNHACUNGCAP_HOMEPAGE_ONE_FAILD, error } }
}

function updateFilter(payload) {
    return { type: NEWDANHMUCNHACUNGCAP_UPDATE_FILTER, data: payload }
}

function listNoLimit() {
    return (dispatch, getState) => {
      const { account } = getState()
      dispatch(AppAction.appLoading(true));
      NewdanhmucnhacungcapService.listNoLimit().then((rs) => {
        dispatch(success({
            items: rs.data.values,
            total: rs.data.count
        }));
      }).catch((error) => {
        dispatch(failure(error));
      }).finally(() => {
        dispatch(AppAction.appLoading(false));
      })
    };
    function success(data) { return { type: NEWDANHMUCNHACUNGCAP_LIST_SUCCESS, data } }
    function failure(error) { return { type: NEWDANHMUCNHACUNGCAP_LIST_FAILD, error } }
  }

function countAssign() {
    return (dispatch) => {
        dispatch(AppAction.appLoading(true));
        NewdanhmucnhacungcapService.countAssign().then((rs) => {
            dispatch(success(rs.data.total));
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: NEWDANHMUCNHACUNGCAP_COUNT_ASSIGN_SUCCESS, data } }
    function failure(error) { return { type: NEWDANHMUCNHACUNGCAP_COUNT_ASSIGN_FAILD, error } }
}

function findAssign(page = 0, count = 20) {
    return (dispatch, getState) => {
        const { newdanhmucnhacungcap } = getState()
        dispatch(AppAction.appLoading(true));
        NewdanhmucnhacungcapService.findAssign(page, count).then((rs) => {
            if (page === 0) {
                dispatch(success({
                    items: rs.data.values,
                    total: rs.data.count
                }));
            } else {
                dispatch(success({
                    items: [...newdanhmucnhacungcap.items, ...rs.data.values],
                    total: rs.data.count
                }));
            }
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: NEWDANHMUCNHACUNGCAP_LIST_SUCCESS, data } }
    function failure(error) { return { type: NEWDANHMUCNHACUNGCAP_LIST_FAILD, error } }
}

function saveDataUpload(payload) {
    return (dispatch) => {
        dispatch(AppAction.appLoading(true));
        let count = 0;
        let errorRows = {};
        for (let i = 0; i < payload.length; i += 200) {
            // eslint-disable-next-line no-loop-func
            NewdanhmucnhacungcapService.save(payload.slice(i, i + 200)).then((rs) => {
                count += parseInt(rs.data.saved, 10)
                // if (count === payload.length) {
                //     dispatch(success(rs));
                //     dispatch(AppAction.appLoading(false));
                // }

                if (rs.data.errorRows) {
                    Object.entries(rs.data.errorRows).forEach(([key, value]) => {
                        errorRows[i * 200 + Number(key)] = value;
                    });
                }

                if (i + 200 >= payload.length) {
                    dispatch(handleErrors(errorRows));
                    dispatch(success(rs));
                    dispatch(NewdanhmucnhacungcapAction.list());
                    alert("Tải file thành công: \"" + payload[0].ten_file_upload + "\" (" + count + " bản ghi)");
                }
            }).catch((error) => {
                dispatch(failure(error));
                dispatch(AppAction.appLoading(false));
            })
        }
    };

    function handleErrors(data) { return { type: NEWDANHMUCNHACUNGCAP_HANDLE_IMPORT_ERRORS, data } }
    function success(data) { return { type: NEWDANHMUCNHACUNGCAP_SAVE_SUCCESS, data } }
    function failure(error) { return { type: NEWDANHMUCNHACUNGCAP_SAVE_FAILD, error } }
}

function findPackage(ten_goi_cuoc) {    
    return (dispatch, getState) => {
        return new Promise((resolve, reject) => {
            // Perform your asynchronous operation (e.g., API call)
            NewdanhmucnhacungcapService.findPackage(ten_goi_cuoc)
            .then(response => {
                // Handle the successful response
                resolve(response); // Resolve the promise with the response
            })
            .catch(error => {
                // Handle the error
                reject(error); // Reject the promise with the error
            });
        });
    };
}

function listExport() {
    return (dispatch, getState) => {
        return new Promise((resolve, reject) => {
            const { newdanhmucnhacungcap } = getState();

            const { filter } = newdanhmucnhacungcap;

            // Perform your asynchronous operation (e.g., API call)
            NewdanhmucnhacungcapService.listExport(filter)
            .then(response => {
                // Handle the successful response
                dispatch(success(response));
                resolve(response); // Resolve the promise with the response
            })
            .catch(error => {
                // Handle the error
                dispatch(failure(error));
                reject(error); // Reject the promise with the error
            });
        });
    }
    function success(data) { return { type: NEWDANHMUCNHACUNGCAP_LIST_EXPORT_SUCCESS, data } }
    function failure(error) { return { type: NEWDANHMUCNHACUNGCAP_LIST_EXPORT_FAILD, error } }
}

function list() {
    return (dispatch, getState) => {
        const { newdanhmucnhacungcap } = getState();
        dispatch(AppAction.appLoading(true));

        const { filter } = newdanhmucnhacungcap;
        const page = filter.page;
        const limit = filter.limit;

        return new Promise((resolve, reject) => {
            NewdanhmucnhacungcapService.findAll(filter.page, filter.limit, filter).then((rs) => {
                if (!!filter && filter.page === 0) {
                    dispatch(success({
                        items: rs.data.values,
                        total: rs.data.count,
                    }));
                } else {
                    const oldItems = newdanhmucnhacungcap.items;
                    const rsDataValues = rs.data.values;

                    var uniqueItems = oldItems;
                    for (var i = limit * page; i < limit * page + limit; i++) {
                        if (typeof rsDataValues[i - limit * page] !== 'undefined') {
                            uniqueItems[i] = rsDataValues[i - limit * page];
                        } else if (typeof uniqueItems[i] !== 'undefined') {
                            delete uniqueItems[i];
                        }
                    }
                    
                    dispatch(success({
                        items: uniqueItems,
                        total: rs.data.count,
                    }));
                }
                resolve(rs);
            }).catch((error) => {
                dispatch(failure(error));
                reject(error);
            }).finally(() => {
                dispatch(AppAction.appLoading(false));
            })
        });
    };
    function success(data) { return { type: NEWDANHMUCNHACUNGCAP_LIST_SUCCESS, data } }
    function failure(error) { return { type: NEWDANHMUCNHACUNGCAP_LIST_FAILD, error } }
}

function importData(payload) {
    return { type: NEWDANHMUCNHACUNGCAP_IMPORT_SUCCESS, data: payload }
}

function saveData(payload) {
    return (dispatch) => {
        dispatch(AppAction.appLoading(true));
        let count = 0
        for (let i = 0; i < payload.length; i += 200) {
            // eslint-disable-next-line no-loop-func
            NewdanhmucnhacungcapService.save(payload.slice(i, i + 200)).then((rs) => {
                count += parseInt(rs.data.saved, 10)
                if (count === payload.length) {
                    dispatch(success(rs));
                    dispatch(NewdanhmucnhacungcapAction.list())
                    dispatch(AppAction.appLoading(false));
                }
            }).catch((error) => {
                dispatch(failure(error));
                dispatch(AppAction.appLoading(false));
            })
        }
    };

    function success(data) { return { type: NEWDANHMUCNHACUNGCAP_SAVE_SUCCESS, data } }
    function failure(error) { return { type: NEWDANHMUCNHACUNGCAP_SAVE_FAILD, error } }
}

function create(payload, creatingFromAway = false) {
    return dispatch => {
        if (!creatingFromAway) dispatch(AppAction.appLoading(true));
        NewdanhmucnhacungcapService.create(payload).then((rs) => {
            dispatch(success(rs));
            if (!creatingFromAway) dispatch(NewdanhmucnhacungcapAction.list())
        }).catch((error) => {
            dispatch(failure(error));
            alert("Không thể tạo, có thể do trùng mã!");
        }).finally(() => {
            if (!creatingFromAway) dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: NEWDANHMUCNHACUNGCAP_CREATE_SUCCESS, data } }
    function failure(error) { return { type: NEWDANHMUCNHACUNGCAP_CREATE_FAILD, error } }
}

function update(id, payload) {
    return dispatch => {
        dispatch(AppAction.appLoading(true));
        NewdanhmucnhacungcapService.update(id, payload).then((rs) => {
            dispatch(success(rs));
            dispatch(NewdanhmucnhacungcapAction.list())
        }).catch((error) => {
            dispatch(failure(error));
            alert("Không thể cập nhật, có thể do trùng mã!");
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: NEWDANHMUCNHACUNGCAP_CREATE_SUCCESS, data } }
    function failure(error) { return { type: NEWDANHMUCNHACUNGCAP_CREATE_FAILD, error } }
}

function del(id) {
    return dispatch => {
        dispatch(AppAction.appLoading(true));
        NewdanhmucnhacungcapService.delete(id).then((rs) => {
            dispatch(success(rs));
            dispatch(NewdanhmucnhacungcapAction.list())
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: NEWDANHMUCNHACUNGCAP_DEL_SUCCESS, data } }
    function failure(error) { return { type: NEWDANHMUCNHACUNGCAP_DEL_FAILD, error } }
}

function findOne(id) {
    return (dispatch) => {
        dispatch(AppAction.appLoading(true));
        NewdanhmucnhacungcapService.find(id).then((rs) => {
            dispatch(success(rs.data));
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: NEWDANHMUCNHACUNGCAP_ONE_SUCCESS, data } }
    function failure(error) { return { type: NEWDANHMUCNHACUNGCAP_ONE_FAILD, error } }
}

function assign(payload) {
    return dispatch => {
        dispatch(AppAction.appLoading(true));
        NewdanhmucnhacungcapService.assign(payload).then((rs) => {
            showToast('success', "Phân chia dữ liệu thành công.")
            dispatch(NewdanhmucnhacungcapAction.list())
        }).catch((error) => {
            showToast('error', "Phân chia dữ liệu thất bại.\nVui lòng thử lại lần sau.")
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
}

function history(payload) {
    return (dispatch, getState) => {
        const { newdanhmucnhacungcap } = getState()
        dispatch(AppAction.appLoading(true));
        NewdanhmucnhacungcapService.history(payload).then((rs) => {
            if (payload.page === 0) {
                dispatch(success({
                    items: rs.data.values,
                    total: rs.data.count
                }));
            } else {
                dispatch(success({
                    items: [...newdanhmucnhacungcap.items, ...rs.data.values],
                    total: rs.data.count
                }));
            }
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: NEWDANHMUCNHACUNGCAP_HISTORY_LIST_SUCCESS, data } }
    function failure(error) { return { type: NEWDANHMUCNHACUNGCAP_HISTORY_LIST_FAILD, error } }
}

function sendOrder(payload) {
    return dispatch => {
        dispatch(AppAction.appLoading(true));
        NewdanhmucnhacungcapService.sendOrder(payload).then((rs) => {
            dispatch(success(rs));
            alert("Đặt hàng thành công!");
        }).catch((error) => {
            dispatch(failure(error));
            alert("Không thể đặt sim này, có thể do hiện tại sim này đã bán. Bạn vui lòng chọn sim khác. Xin cảm ơn!");
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: NEWDANHMUCNHACUNGCAP_ORDER_SUCCESS, data } }
    function failure(error) { return { type: NEWDANHMUCNHACUNGCAP_ORDER_FAILD, error } }
}